import { render } from "./UnsavedChangesConfirmDialog.vue?vue&type=template&id=4dfd48ed"
import script from "./UnsavedChangesConfirmDialog.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__